let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lA0j4")).then(() => parcelRequire('Jq3ih'));